interface SectionHeadingProps {
  label: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ label, title, desc }: SectionHeadingProps) {
  return (
    <div className="max-w-3xl">
      <div className="flex items-center gap-3 mb-3">
        <span className="w-6 h-px bg-primary-500"></span>
        <span className="text-xs tracking-[0.25em] font-medium text-primary-600 uppercase">{label}</span>
      </div>
      <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">{title}</h2>
      {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
    </div>
  );
}